//('a haystack with a needle').fuzzy('hay sucks');    // false
// ('a haystack with a needle').fuzzy('sack hand');    // true
// via https://stackoverflow.com/questions/9206013/javascript-fuzzy-search
export const fuzzySearch = (searchQuery:string, searchedString:string) => {
    let hay = searchedString.toLowerCase(), i = 0, n = -1, l;
    searchQuery = searchQuery.toLowerCase();
    for (; l = searchQuery[i++] ;) if (!~(n = hay.indexOf(l, n + 1))) return false;
    return true;
};